import React from "react";

interface ButtonProps {
  variant: "primary" | "secondary";
  text: string;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({ variant, text, onClick }) => {
  const baseClasses =
    "px-6 py-3.5 text-base text-center rounded border border-solid shadow-sm cursor-pointer min-w-[138px] max-sm:w-full";

  const variantClasses = {
    primary: "text-white bg-orange-500 border-orange-500 hover:bg-orange-400",
    secondary: "text-orange-500 border-orange-500 bg-transparent hover:bg-orange-500 hover:text-white",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;